import React from "react";
import styled from "styled-components";
import CardHorizontal from "./cardNews/CardHorizontal";
import CardHorizontalWithLargeThumbnail from "./cardNews/CardHorizontalWithLargeThumbnail";
import CardHorizontalWithThumbnail from "./cardNews/CardHorizontalWithThumbnail";
import CardTextOnImage from "./cardNews/CardTextOnImage";
import CardVertical from "./cardNews/CardVertical";
import CardWithTitle from "./cardNews/CardWithTitle";

const VerticalCardDiv = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.grid};
  grid-column-gap: 17px;
  grid-row-gap: 60px;

  @media screen and (max-width: 899px) {
    grid-template-columns: 25% 25% 25% 25%;
  }
  @media screen and (max-width: 699px) {
    grid-template-columns: 33% 33% 33%;
  }
  @media screen and (max-width: 420px) {
    display: block;
  }
`;

const NewsList = ({ newsList, type, size, main = "" }) => {
  const length = Number(size);

  console.log(type);

  const NewsType = () => {
    switch (type) {
      case "horizontal":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => <CardHorizontal key={idx} news={news} />)
        );
      case "horizontal_with_lg_thumb":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => (
              <CardHorizontalWithLargeThumbnail key={idx} news={news} />
            ))
        );
      case "horizontal_with_thumb":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => (
              <CardHorizontalWithThumbnail key={idx} news={news} main={main} />
            ))
        );
      case "text_on_img":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => <CardTextOnImage key={idx} news={news} />)
        );
      case "vertical":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => (
              <CardVertical key={idx} news={news} main={main} />
            ))
        );
      case "title":
        return (
          newsList &&
          newsList
            .slice(0, length)
            .map((news, idx) => <CardWithTitle key={idx} news={news} />)
        );
      default:
        return <div>뉴스 없음</div>;
    }
  };

  if (type === "vertical") {
    return (
      <VerticalCardDiv
        grid={!!main ? "31.5% 31.5% 31.5%" : "19% 19% 19% 19% 19%"}
      >
        <NewsType />
      </VerticalCardDiv>
    );
  } else {
    return (
      <div style={{ display: "block" }}>
        <NewsType />
      </div>
    );
  }
};

export default NewsList;
